import type { Placement } from '@popperjs/core';
import type { Underlying } from 'models/underlying';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { UnderlyingSearch } from 'models/underlying/underlying-search';
import type { ReactNode } from 'react';
import { FocusEvent, KeyboardEvent } from 'react';
import { connect } from 'react-redux';
import { getUserPreferencesUnderlyingCodeType } from 'state/selectors';
import type { AppState } from 'state/state.model';

import { BatchSingleUnderlyingFieldComponent } from './BatchSingleUnderlyingFieldComponent';
import { BatchSingleUnderlyingFieldWithCutoffComponent } from './BatchSingleUnderlyingFieldWithCutoffComponent';

type OwnProps = UnderlyingSearch & {
  id?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  tabIndex?: number;
  className?: string;
  onBlur?(event: FocusEvent<HTMLElement>): void;
  onChange(underlying: Underlying | undefined): void;
  tooltipPlacement?: Placement;
  children?: ReactNode;
  isCellInactive?: boolean;
  isFocused?: boolean;
  onEditingKeyDown?: (e: KeyboardEvent) => void;
  lostInputBeforeEditing?: string;
  onTagChanged: () => void;
  onInputChanged: () => void;
};

interface StateProps {
  defaultUnderlyingCodeType: UnderlyingCodeType;
}

export type UnderlyingsFieldProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, _own: OwnProps): StateProps => {
  const defaultUnderlyingCodeType = getUserPreferencesUnderlyingCodeType(state, 'Reuters');
  return {
    defaultUnderlyingCodeType,
  };
};

export const connectUnderlyingField = connect<StateProps, unknown, OwnProps, AppState>(mapStateToProps);

export const BatchSingleUnderlying = connectUnderlyingField(BatchSingleUnderlyingFieldComponent);
export const BatchSingleUnderlyingWithCutoff = connectUnderlyingField(BatchSingleUnderlyingFieldWithCutoffComponent);
